/**
 * Centralized Terminology Configuration
 * 
 * This file allows you to easily change terminology across the application.
 * To change "Quota" to something else, simply update the values below.
 * 
 * Usage:
 *   import TERMS, { replaceQuotaTerm } from '../config/terminology';
 *   // or: import { TERMS, replaceQuotaTerm } from '../config/terminology';
 * 
 * Then use TERMS.QUOTA, TERMS.QUOTA_PLURAL, etc. in your components.
 * Use replaceQuotaTerm(text) to dynamically replace "Quota"/"Quotas" in any string.
 */

const TERMINOLOGY_CONFIG = {
  USE_NEW_TERMINOLOGY: false,

  ORIGINAL: {
    QUOTA: 'Quota',
    QUOTA_PLURAL: 'Quotas',
    QUOTA_FULL: 'Quota',
  },

  NEW: {
    QUOTA: 'Res. Allocation',
    QUOTA_PLURAL: 'Res. Allocations',
    QUOTA_FULL: 'Resource Allocation',
  },
};

function getActiveTerms() {
  return TERMINOLOGY_CONFIG.USE_NEW_TERMINOLOGY
    ? TERMINOLOGY_CONFIG.NEW
    : TERMINOLOGY_CONFIG.ORIGINAL;
}

export const TERMS = {
  get QUOTA() { return getActiveTerms().QUOTA; },
  get QUOTA_PLURAL() { return getActiveTerms().QUOTA_PLURAL; },
  get QUOTA_FULL() { return getActiveTerms().QUOTA_FULL; },
};

/** Define screen / chart display labels (API and variable names unchanged). */
export const DEFINE_FORECAST_LABELS = {
  UNCONSTRAINED: "Unconstrained Forecast",
  CONSTRAINED: "Driver adjusted forecast",
};

const FORECAST_UI_DISPLAY_REPLACEMENTS = [
  ["Suggested Forecast", DEFINE_FORECAST_LABELS.UNCONSTRAINED],
  ["Decided Forecast", DEFINE_FORECAST_LABELS.CONSTRAINED],
];

export const replaceQuotaTerm = (text) => {
  if (!text || typeof text !== 'string') return text;
  let result = text;
  for (const [from, to] of FORECAST_UI_DISPLAY_REPLACEMENTS) {
    result = result.split(from).join(to);
  }
  const terms = getActiveTerms();
  return result
    .replace(/\bQuotas\b/g, terms.QUOTA_PLURAL)
    .replace(/\bquotas\b/g, terms.QUOTA_PLURAL.toLowerCase())
    .replace(/\bQuota\b/g, terms.QUOTA)
    .replace(/\bquota\b/g, terms.QUOTA.toLowerCase());
};

export const getTooltipText = (term) => {
  if (!TERMINOLOGY_CONFIG.USE_NEW_TERMINOLOGY) return '';
  if (term === TERMS.QUOTA || term === TERMS.QUOTA_PLURAL) {
    return TERMINOLOGY_CONFIG.NEW.QUOTA_FULL;
  }
  return '';
};

export const TERMINOLOGY_CONFIG_REF = TERMINOLOGY_CONFIG;

export default TERMS;
